<!--
     ExplorerDirectoryPath shows a single path

     USAGE:
     <ExplorerDirectoryPath
       :path="activeDirectory.path"
       editable=true
       @edit="my_custom_onedit"
     ></ExplorerDirectoryPath>
-->

<template>
  <span
    v-if="path"
  >
    <span
      v-for="dir in path_obj"
      :key="dir.id">
      <span
        v-if="dir.path.length > 1"
      >
        &gt;
      </span>
      <span style="display: inline-block" class="text-start" v-if="editable">
        <v-select
          :items="list_peer_folders(dir)"
          item-text="state"
          item-value="abbr"
          :label="$vuetify.lang.translator('directory.directory')"
          persistent-hint
          return-object
          single-line
          clearable
          :disabled="disabled"
          @change="update_path"
        >
          <template v-slot:selection="{ item, index }">
            <span>
              <v-icon :color="item.color">
                mdi-folder
              </v-icon>
              {{ item.name }}
            </span>
          </template>
          <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-icon :color="item.color">
                  mdi-folder
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </span>

      <span style="display: inline-block" class="text-start" v-else>
        <v-icon :color="dir.color">
          mdi-folder
        </v-icon>
        {{ dir.name }}
      </span>
    </span>
  </span>
</template>


<script>
 import { mapState } from 'vuex'

 export default {
   name: 'ExplorerDirectoryPath',
   props: ['path', 'editable', 'disabled'],

   data: () => ({
     // data
   }),

   computed: {
     ...mapState(['qdirectory', 'qdirectory_list']),

     path_obj() {
       return this.path.map(id => (id.id === undefined) ? this.qdirectory[id] : id);
     },
   },

   methods: {
     list_peer_folders(dir) {
       // Find folders on the same parent than dir
       // Returns [{folder1}, {folder2}, {folder3}]
       let res;
       if (!dir.parent_id)
         res = this.qdirectory_list;
       else
         res = this.qdirectory[dir.parent_id].children.map(c => this.qdirectory[c]);
       return res;
     },

     update_path(dir) {
       this.path = this.qdirectory[dir.id].path.concat([]);
     },
   },
 }
</script>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>
